<template>
  <div class="settings-subsection">
    <div class="settings-fields">
      <div v-if="showDefaultChannel" class="field-group">
        <div class="flabel">
          <FieldStatusIcon :ok="selectedExists" />
          <span>Канал отправки маркетинговых рассылок (по умолчанию)</span>
        </div>
        <CustomActivatorSelect
          :value="selectedValue"
          @input="updateValue"
          :items="items"
          item-value="value"
          item-name="label"
          :multiple="false"
          class="custom-input mock-input"
        >
          <template v-slot:activator="{ selected, _id }">
            <BaseInputOutlined
              :id="_id"
              :value="selected ? selected.label : ''"
              label="Выберите канал"
              readonly
              class="select-input"
              append-icon="mdi-menu-down"
              hide-details
            />
          </template>
        </CustomActivatorSelect>
      </div>

      <div class="vargroup-lab">Переменные для подстановки</div>

      <div class="field-group">
        <div class="flabel">
          <span>Дата-мероприятия</span>
          <span class="opt">*необязательное</span>
        </div>
        <BaseInputOutlined
          label="Введите значение"
          :value="settings['eventDate']"
          @input="updateSetting('eventDate', $event)"
          class="custom-input mock-input"
          hide-details
        />
      </div>

      <div class="field-group">
        <div class="flabel">
          <span>Ссылка-на-отзывы</span>
          <span class="opt">*необязательное</span>
        </div>
        <BaseInputOutlined
          label="Введите значение"
          :value="settings['reviewLink']"
          @input="updateSetting('reviewLink', $event)"
          class="custom-input mock-input"
          hide-details
        />
      </div>

      <div class="field-group">
        <div class="flabel">
          <span>Название-подарка</span>
          <span class="opt">*необязательное</span>
        </div>
        <BaseInputOutlined
          label="Введите значение"
          :value="settings['giftName']"
          @input="updateSetting('giftName', $event)"
          class="custom-input mock-input"
          hide-details
        />
      </div>

      <div class="field-group">
        <div class="flabel">
          <span>Ссылка-на-онлайн-запись</span>
          <span class="opt">*необязательное</span>
        </div>
        <BaseInputOutlined
          label="Введите значение"
          :value="settings['bookingLink']"
          @input="updateSetting('bookingLink', $event)"
          class="custom-input mock-input"
          hide-details
        />
      </div>
      <template v-if="isSuperUser">
        <div
          v-for="field in extraVarFields"
          :key="field.key"
          class="field-group"
        >
          <div class="flabel">
            <span>{{ field.label }}</span>
            <span class="opt">*необязательное</span>
          </div>
          <BaseInputOutlined
            label="Введите значение"
            :value="settings[field.key]"
            @input="updateSetting(field.key, $event)"
            class="custom-input mock-input"
            hide-details
          />
        </div>
      </template>

      <div class="field-group">
        <div class="flabel">
          <span>Лимит сообщений в день для пакетной отправки</span>
        </div>
        <template v-if="showDailyLimit">
          <BaseInputOutlined
            label="Введите значение"
            :value="settings['dailyLimit']"
            @input="updateSetting('dailyLimit', $event)"
            class="custom-input mock-input"
            type="number"
            hide-details
          />
          <div class="note-warn">
            <b>Внимание!</b> Данные лимиты применяются для пакетной рассылки по всем активациям. Установленный
            лимит работает для всех активаций единовременно.
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import BaseInputOutlined from '@/components/inputs/BaseInputOutlined.vue'
import CustomActivatorSelect from '@/components/inputs/CustomActivatorSelect.vue'
import FieldStatusIcon from '@/components/ClientNotifications/NotificationSettingsBlocks/FieldStatusIcon.vue'
import config from '@root/config'

export default defineComponent({
  name: 'MarketingMailingsBlock',
  components: { BaseInputOutlined, CustomActivatorSelect, FieldStatusIcon },
  props: {
    settings: { type: Object, required: true },
    updateSetting: { type: Function, required: true },
    items: { type: Array, required: true },
    selectedValue: { type: [String, Object, null], default: null },
    updateValue: { type: Function, required: true },
    selectedExists: { type: Boolean, default: false },
    showDailyLimit: { type: Boolean, default: true },
    showDefaultChannel: { type: Boolean, default: true },
    extraVarFields: { type: Array, default: () => [] },
  },
  computed: {
    isSuperUser() {
      return config.adminsWhitelist.includes(this.$auth.user.sub)
    },
  },
})
</script>

<style lang="sass" scoped>
.settings-fields
  display: flex
  flex-direction: column
  gap: 14px

.field-group
  display: flex
  flex-direction: column
  gap: 9px

.flabel
  display: flex
  align-items: center
  gap: 7px
  font-size: 13px
  color: #1F2440

.opt
  color: #AAB2C4
  font-size: 11px

.vargroup-lab
  font-family: Geologica, sans-serif
  font-size: 13px
  font-weight: 800
  color: #1A1A2E
  margin-top: 0

.note-warn
  background: #FFF7EA
  border: 1px solid #F6D69A
  border-radius: 11px
  padding: 13px 16px
  font-size: 12.5px
  line-height: 1.5
  color: #7A5A12

  b
    color: #A8431A
</style>
